import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'components/atoms/Button/Button';
import Title from 'components/atoms/Title/Title';
import Paragraph from 'components/atoms/Paragraph/Paragraph';
import Divider from 'components/atoms/Divider/Divider';
import Division from 'components/atoms/Division/Division';
import { useSectionProfileStyles } from './sectionProfileStyles';
import { useHistory } from 'react-router-dom';
import { ROUTE_TRAIT_DETAILS } from 'routes';
import { Fragment } from 'react';
import CircleGroup from 'components/molecules/Circle/CircleGroup';
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';

export default function SectionProfile(props) {
  const classes = useSectionProfileStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const { traitsData, allTraits } = props.data;
  const [sectionProfiles, setSectionProfiles] = useState(traitsData);
  const [showAllTraitsButtonVisible, setShowAllTraitsButtonVisible] = useState(
    true
  );
  const sectionParts =
    sectionProfiles &&
    sectionProfiles.map((item, index) => {
      return (
        <Fragment>
          <Division className={classes.tileContainer}>
            <Division
              style={{
                textAlign: 'center',
                marginTop: '8px',
                minHeight: '70px',
              }}
            >
              <Title variant="h1">{item.title}</Title>
            </Division>

            <Division style={{ paddingTop: '12px', paddingBottom: '16px' }}>
              <CircleGroup item={item} />
            </Division>

            <Division
              style={{
                marginTop: '20px',
                padding: '8px',
                paddingBottom: '16px',
                textAlign: 'justify',
              }}
            >
              <Paragraph>{item.paragraph}</Paragraph>
            </Division>

            <Division className={classes.tileFooter}>
              <Button
                size="large"
                fullWidth
                onClick={() => {
                  history.push(`${ROUTE_TRAIT_DETAILS}?code=${item.buttonUrl}`);
                }}
              >
                <Trans i18nKey="dna24.viewDetails" />
              </Button>

              <Divider orientation="horizontal" flexItem />
            </Division>
          </Division>
          {index % 2 === 0 && (
            <Division
              style={{
                width: '6px',
                background: '#cccccc',
                marginTop: '8px',
                marginBottom: '24px',
              }}
            />
          )}
        </Fragment>
      );
    });

  return (
    <Division style={{ marginBottom: '12px' }}>
      <Division className={classes.tileRoot}>
        {sectionParts}

        {/* Render empty tile to keep grid if number of elements is not even */}
        {sectionParts.length % 2 !== 0 && (
          <Division className={classes.tileContainer} />
        )}
      </Division>

      <Division
        style={{ marginTop: 5, display: 'flex', justifyContent: 'center' }}
      >
        {showAllTraitsButtonVisible && (
          <Division style={{ padding: '8px' }}>
            <Button
              variant="contained"
              size="large"
              onClick={() => {
                setSectionProfiles(allTraits);
                setShowAllTraitsButtonVisible(false);
              }}
            >
              <Trans i18nKey="dna24.showAllTraits" />
            </Button>
          </Division>
        )}

        <Division style={{ padding: '8px' }}>
          <Button
            variant="contained"
            size="large"
            disabled={!props.reportDownloadUrl}
            onClick={() => {
              window.open(
                props.reportDownloadUrl,
                '_blank',
                'noopener,noreferrer'
              );
            }}
          >
            {props.reportDownloadUrl
              ? t('dna24.downloadPdfReport')
              : t('dna24.preparingPdfReport')}
          </Button>
        </Division>
      </Division>
    </Division>
  );
}

SectionProfile.propTypes = {
  children: PropTypes.node.isRequired,
};
